export default __webpack_public_path__ + "static/media/coffe3.05e78e6f.png";